/**
 * jQuery Formulate
 * Version 2.5
 * Copyright 2021 Jonah Digital
 *
 * ----------------------------------------------------------------------------
 * RELEASE NOTES
 * ----------------------------------------------------------------------------
 * Version 2.5
 * Added checkbox validation
 * Added ability to halt form submission in fireOnSuccess to be able to use
 * custom validation
 *
 * Version 2.4
 * Changed variables and functions to be publicly accessible
 *
 * Version 2.3
 * Now supports file upload!!
 * - form element must contain enctype="multipart/form-data" attribute
 * - Example: <form action="/url/to/go/" method="post" enctype="multipart/form-data">
 *
 *
 * ----------------------------------------------------------------------------
 * OPTIONS
 * ----------------------------------------------------------------------------
 * submitClass      - default "submitting" The class name that will get put on the <form> element when submitting the form
 * errorClass       - default "error"      The class name that will get put on the <input> element (default) or on ALL
 *                                         elements that you specify
 * ajaxSuccess      - default "success"    What the result of .post will look for in order to know if the PHP succeeded
 * inlineMsg        - default FALSE        Span elements that can be used maybe inside an input to indicate the error
 *                                         message
 * inlineMsgClass   - default "error_msg"  Class that gets applied to the inline message span
 * errorParent      - default FALSE        If true, then the errorClass will get put on the element's parent. Or you
 *                                         can pass an element selected and it will go up from the INPUT until it find
 *                                         the first parent with that matching selector.
 * errorLabel       - default FALSE        If true, then the errorClass will get put on the fields label
 * hideFormOnSubmit - default TRUE         Will hide (display:none) the form once it's submitted. Set to FALSE if you
 *                                         want the form to stay visible FOREVER.
 * ajax             - default TRUE         Set to FALSE if you don't want to use AJAX and force page load to the action=""
 * hideOnSubmit     - string               CSV list of elements that will get hidden on the form submit
 * showOnSubmit     - string               CSV list of elements that will get shown on the form submit (like a SUCCESS msg)
 * onSubmit         - function             Callback that gets triggered when the submit is triggered
 * onError          - function             Callback that gets triggered when the AJAX response from PHP is an error
 * onSuccess        - function             Callback that gets triggered when the AJAX response from PHP is success
 *
 * conditional      - string               CSV list of form field NAME values that you want to be validated (not necessarily required)
 *                                         Examples:
 *                                         Email{email},FirstName{minLength=2}
 *
 * *** TO BE REPLACED BY "validate" below - TODO: will need to be written
 * required         - string               CSV list of form field NAME values that you want to be marked as required
 *                                         Examples:
 *                                         Email{email|phone|integer},FirstName,LastName
 *
 * @todo validate   - string               URL structured list of field NAMEs with the validation requirements for each field
 *                                         Example:
 *                                         Email=required|minLengh=3|email&FirstName=required&LastName=required&Age=integer|required&MyCheckbox=required
 */
$.fn.formulate = function(settings) {
  'use strict';

  // --------------------------------------------------------------------------
  //  Variables
  // --------------------------------------------------------------------------
  var _ = this;

  _.conditionalFields = null;
  _.submitted         = false;
  _.customErrorLabel  = false;
  _.aErroredFields    = [];

  _.defaults = {
    errorClass       : 'error',
    ajaxSuccess      : 'success',
    inlineMsgClass   : 'error_msg',
    submitClass      : 'submitting',
    inlineMsg        : false,
    errorParent      : false,
    errorLabel       : false,
    hideFormOnSubmit : true,
    ajax             : true
  };

  _.settings = $.extend({}, _.defaults, settings);

  if (_.settings.require) {
    _.required = _.settings.require.split(',');
  }

  if (_.settings.conditional) {
    _.conditionalFields = _.settings.conditional.split(',');
  }

  if (_.settings.errorLabel !== true && _.settings.errorLabel !== false) {
    _.customErrorLabel = true;
  }



  // ----------------------------------------------------------------------------
  //  Time to make the donuts!
  // ----------------------------------------------------------------------------
  // Handle Hide On Submission
  if (_.settings.hideOnSubmit) {
    _.settings.hideOnSubmit = _.settings.hideOnSubmit.split(',');
    var hidePos = 0;
    var hideElements = $.makeArray();
    $(_.settings.hideOnSubmit).each(function() {
      var currentElement = $.trim(_.settings.hideOnSubmit[hidePos]);
      hideElements.push(currentElement);
      ++hidePos;
    });
  }

  // Handle Show On Submission
  if (_.settings.showOnSubmit) {
    _.settings.showOnSubmit = _.settings.showOnSubmit.split(',');
    var showPos = 0;
    var showElements = $.makeArray();
    $(_.settings.showOnSubmit).each(function() {
      var currentElement = $.trim(_.settings.showOnSubmit[showPos]);
      $(currentElement).hide();
      showElements.push(currentElement);
      ++showPos;
    });
  }

  // Handle errorParent value
  var errorParent;
  if (_.settings.errorParent === true) {
    errorParent = true;
  }
  else if (_.settings.errorParent  !== true && _.settings.errorParent  !== false) {
    var getErrorParent = _.settings.errorParent;
    errorParent = 'custom';
  }

  // Handle inlineMsg value
  var getInlineMsg;
  var customMsg = false;
  if (_.settings.inlineMsg === true) {
    getInlineMsg = 'Required';
  }
  else if (_.settings.inlineMsg !== true && _.settings.inlineMsg !== false) {
    getInlineMsg = _.settings.inlineMsg;
    _.settings.inlineMsg = true;
    customMsg = true;
  }

  _.validateFields = function() {
    // Set Error Count
    var errorCount = 0;
    _.aErroredFields = [];

    // Find all existing inline errors and remove them
    _.find('span#inlineErrorMsg').remove();

    // Function to error fields
    function errorField(currentField, validation, checkboxCount) {
      var findInForm = _.find('[name="' + currentField + '"]');
      var minCountCheck

      if (!findInForm.length) {
        findInForm = _.find('[name="' + currentField + '[]"]');
      }

      // Checks to see if user has entered a validation rule for the field
      function checkForValidation() {
        if (validation) {
          if (validation === 'Email') {
            return !_.validateEmail(findInForm.val());
          }
          else if (validation === 'Phone') {
            return !_.validatePhone(findInForm.val());
          }
          else if (validation === 'Integer') {
            return !_.validateInteger(findInForm.val());
          }
          else if (validation === 'ReCaptcha') {
            return !_.validateReCaptcha(findInForm.val());
          }
          else if (validation === 'File') {
            return !_.validateFile(findInForm);
          }
        }
        else {
          return false;
        }
      }

      // Checks to see if specified field is a Checkbox or Radio
      function isCheckboxOrRadio() {
        if (findInForm.attr('type') === 'checkbox' || findInForm.attr('type') === 'radio'){
          return true;
        }
        else {
          return false;
        }
      }

      // Returns the total number of inputs/fields on the page (including non-input elements)
      function returnInputCount() {
        var inputCount = 0;
        findInForm.each(function(){
          ++inputCount;
        });
        return inputCount;
      }

      // Removes error classes on parent elements
      function removeParentErrors() {
        if (errorParent === true){
          findInForm.parent().removeClass(_.settings.errorClass);
        }
        else if (errorParent === 'custom'){
          findInForm.parents(getErrorParent).removeClass(_.settings.errorClass);
        }
      }

      // Replaces inlineMsg {FIELD} string
      function replaceFieldName(getInlineMsg) {
        if (_.stringExists('{FIELD', getInlineMsg)){
          var fieldName = getInlineMsg.match('{' + "(.*)" + '}');
          if (_.stringExists('.', fieldName[1])){
            var getAttr = fieldName[1].split('.');
            getInlineMsg = getInlineMsg.replace('{' + fieldName[1] + '}', findInForm.attr(getAttr[1]));
          }
          else {
            getInlineMsg = getInlineMsg.replace('{FIELD}', currentField);
          }
        }
        return getInlineMsg;
      }

      if (findInForm.val() === '' || checkForValidation() || isCheckboxOrRadio()) {

        findInForm.addClass(_.settings.errorClass);
        errorCount = 1 + errorCount;

        // Handle Parent Erring
        if (errorParent === true) {
          findInForm.parent().addClass(_.settings.errorClass);
        }
        else if (errorParent === 'custom') {
          findInForm.parents(getErrorParent).addClass(_.settings.errorClass);
        }

        // Handle Label Erring
        if (_.settings.errorLabel === true) {
          findInForm.siblings('label').addClass(_.settings.errorClass);
        }
        else if (_.customErrorLabel) {
          _.find('label[' + _.settings.errorLabel + '=' + currentField + ']').addClass(_.settings.errorClass);
        }

        // Handle inlineMsg output
        if (_.settings.inlineMsg) {
          var inlineMsg;
          if (_.stringExists('{FIELD', getInlineMsg)) {
            inlineMsg = replaceFieldName(getInlineMsg);
          }
          else if (!customMsg && validation && validation !== "Checkbox Counter") {
            if (validation === 'Email') {
              inlineMsg = 'Invalid Email';
            }
            else if (validation === 'File') {
              inlineMsg = 'Invalid File';
            }
            else {
              inlineMsg = 'Invalid';
            }
          }
          else {
            inlineMsg = getInlineMsg;
          }
          if (!isCheckboxOrRadio()) {
            findInForm.after('<span class="' + _.settings.inlineMsgClass + '" id="inlineErrorMsg">' + inlineMsg + '</span>');
          }
        }
        _.aErroredFields.push(findInForm);
      }
      else {
        findInForm.removeClass(_.settings.errorClass);
        removeParentErrors();
        errorCount = 0 + errorCount;
      }

      // Handle Checkbox Actions.
      if (findInForm.attr('type') === 'checkbox') {
        var checkboxPos = 0;
        var checkboxPosAlt = 0;
        var checkboxReq = 1;
        var showErrorMsg = true;

        if (validation === "Checkbox Counter"){
          checkboxReq = parseInt(checkboxCount);
        }
        findInForm.each(function(){
          ++checkboxPosAlt;
          if ($(this).is(':checked')){
            ++checkboxPos;
            if (checkboxPos === checkboxReq){
              findInForm.removeClass(_.settings.errorClass);
              $('#inlineErrorMsgAlt[for="' + $(this).attr('name') + '"]').remove();
              removeParentErrors();
              errorCount = errorCount - 1;
              showErrorMsg = false;
              return false;
            }
            else if (checkboxPos < checkboxReq){
              showErrorMsg = true;
            }
          }
          if (showErrorMsg){
            if (checkboxPosAlt === returnInputCount()){
              $('#inlineErrorMsgAlt[for="' + $(this).attr('name') + '"]').remove();
              if ($(this).parent().get(0).nodeName === 'LABEL'){
                $(this).parent('label').after('<span class="' + _.settings.inlineMsgClass + '" id="inlineErrorMsgAlt" for="' + $(this).attr('name') + '">' + inlineMsg + '</span>');
              }
              else {
                $(this).last().after('<span class="' + _.settings.inlineMsgClass + '" id="inlineErrorMsgAlt">' + inlineMsg + '</span>');
              }
            }
          }
          _.aErroredFields.push(findInForm);
        });
      }

      // Handle Radio Actions.
      if (findInForm.attr('type') === 'radio') {
        var radioCount = 0;
        var showErrorMsgAlt = true;
        findInForm.each(function() {
          ++radioCount;
          if ($(this).is(':checked')) {
            findInForm.removeClass(_.settings.errorClass);
            removeParentErrors();
            $('#inlineErrorMsgAlt[for="' + $(this).attr('name') + '"]').remove();
            errorCount = errorCount - 1;
            showErrorMsgAlt = false;
            return false;
          }
          else {
            showErrorMsgAlt = true;
          }
          if (showErrorMsgAlt) {
            if (radioCount === returnInputCount()) {
              $('#inlineErrorMsgAlt[for="' + $(this).attr('name') + '"]').remove();
              if ($(this).parent().get(0).nodeName === 'LABEL') {
                $(this).parent('label').after('<span class="' + _.settings.inlineMsgClass + '" id="inlineErrorMsgAlt" for="' + $(this).attr('name') + '">' + inlineMsg + '</span>');
              }
              else {
                $(this).last().after('<span class="' + _.settings.inlineMsgClass + '" id="inlineErrorMsgAlt">' + inlineMsg + '</span>');
              }
            }
          }
          _.aErroredFields.push(findInForm);
        });
      }

      return errorCount;
    }

    // Handle Field Validation
    var fieldPos = 0;
    var conFieldPos = 0;

    // Loop through conditional fields, and add them to required field array only if value is not empty
    $(_.conditionalFields).each(function() {
      var currentConField = $.trim(_.conditionalFields[conFieldPos]);
      var formattedConField = null;
      if (_.stringExists('{', currentConField)) {
        var conFieldVal = currentConField.match('{' + "(.*)" + '}');
        var replaceVal = '{' + conFieldVal[1] + '}';
        formattedConField = currentConField.replace(replaceVal, '');
      }
      var findConField = $(document).find('[name=' + formattedConField + ']');
      if (findConField.val() !== '') {
        if ($.inArray(currentConField, _.required) === -1) {
          _.required.push(currentConField);
        }
      }
      else {
        var index = _.required.indexOf(currentConField);
        if ($.inArray(currentConField, _.required) !== -1 && index > -1) {
          _.required.splice(_.required.indexOf(currentConField), 1);

          // Remove Errors
          findConField.removeClass(_.settings.errorClass);
          if (errorParent === true) {
            findConField.parent().removeClass(_.settings.errorClass);
          }
          else if (errorParent === 'custom') {
            findConField.parents(getErrorParent).removeClass(_.settings.errorClass);
          }

        }
      }
      ++conFieldPos;
    });

    // Loop through and find all required fields, error if empty
    $(_.required).each(function() {
      var validation = false;
      var currentField = $.trim(_.required[fieldPos]);

      // Related to Checkbox Counter
      var checkboxCountVal;
      var isCheckboxCounter = false;
      var checkboxCount = 1;
      if (_.stringExists('{', currentField)) {
        checkboxCountVal = currentField.match('{' + "(.*)" + '}');
        if ($.isNumeric(checkboxCountVal[1])) {
          isCheckboxCounter = true;
        }
      }

      // Handle Validation
      if (_.stringExists('{email}', currentField)) {
        currentField = currentField.replace('{email}', '');
        validation = 'Email';
      }
      else if (_.stringExists('{phone}', currentField)) {
        currentField = currentField.replace('{phone}', '');
        validation = 'Phone';
      }
      else if (_.stringExists('{integer}', currentField)) {
        currentField = currentField.replace('{integer}', '');
        validation = 'Integer';
      }
      else if (_.stringExists('{recaptcha}', currentField)) {
        currentField = currentField.replace('{recaptcha}', '');
        validation = 'ReCaptcha';
      }
      else if (_.stringExists('{file}', currentField)) {
        currentField = currentField.replace('{file}', '');
        validation = 'File';
      }
      else if (isCheckboxCounter) {
        if (_.stringExists('{' + checkboxCountVal[1] + '}', currentField)) {
          checkboxCount = checkboxCountVal[1];
          currentField = currentField.replace('{' + checkboxCountVal[1] + '}', '');
          validation = 'Checkbox Counter';
        }
      }

      // Find field in specified form, error if empty
      if (validation) {
        if (validation !== 'Checkbox Counter') {
          errorField(currentField, validation);
        }
        else {
          errorField(currentField, validation, checkboxCount);
        }
      }
      else {
        errorField(currentField);
      }
      ++fieldPos;
    });

    return errorField();
  };

  // Perform actions on form submission
  _.submit(function(e) {
    _.validateOnChange();
    var form = this;
    var data = false;
    var submit = true;

    // add form element to settings
    _.settings.form = form;

    // Add submitting class to form
    _.addClass(_.settings.submitClass);

    // Fire custom user function, if exists
    if ($.isFunction(_.settings.fireOnSubmit)) {
      submit = _.settings.fireOnSubmit.call(_, data, form, settings) !== false;
    }

    if (!_.settings.ajax) {
      if (_.validateFields() !== 0) {
        e.preventDefault();
        // Remove submitting class from form
        _.removeClass(_.settings.submitClass);
        // Fire custom user function, if exists
        if ($.isFunction(_.settings.fireOnError)) {
          _.settings.fireOnError.call(_, data, form, settings);
        }
      }
    }

    if (_.settings.ajax) {
      e.preventDefault();
      if (_.validateFields() === 0) {

        // Perform AJAX operation
        var formData = new FormData(form);

        if (_.settings.id) {
          formData.append('formID', _.settings.id);
        }

        if (submit === false) {
          _.removeClass(_.settings.submitClass);
          return false;
        }

        $.ajax({
          url: _.attr('action'),
          type: 'POST',
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          success: function(data) {
            // Remove submitting class from form
            _.removeClass(_.settings.submitClass);
            if (data === _.settings.ajaxSuccess) {
              if (_.settings.hideFormOnSubmit) {
                _.hide();
              }

              // Fire custom user function, if exists
              if ($.isFunction(_.settings.fireOnSuccess)) {
                _.settings.fireOnSuccess.call(_, data, form, settings);
              }

              // Handle hiding elements on submit
              if (_.settings.hideOnSubmit) {
                var hidePos = 0;
                $(hideElements).each(function() {
                  var findElement = hideElements[hidePos];
                  if ($(document).find(findElement).length !== 0) {
                    $(findElement).hide();
                  }
                  else {
                    console.error('Formulate: Could not hide element "' + findElement + '" because it could not be found in the DOM tree.');
                  }
                  ++hidePos;
                });
              }

              // Handle showing elements on submit
              if (_.settings.showOnSubmit) {
                var showPos = 0;
                $(showElements).each(function() {
                  var findElement = showElements[showPos];
                  if ($(document).find(findElement).length !== 0) {
                    $(findElement).show();
                  }
                  else {
                    console.error('Formulate: Could not show element "' + findElement + '" because it could not be found in the DOM tree.');
                  }
                  ++showPos;
                });
              }
            }
            else {
              // Fire fireOnError function
              if ($.isFunction(_.settings.fireOnError)) {
                _.settings.fireOnError.call(_, data, form, settings);
              }
            }
          },
          error: function (data) {
            // Remove submitting class from form
            _.removeClass(_.settings.submitClass);
            // Fire fireOnError function
            if ($.isFunction(_.settings.fireOnError)) {
              _.settings.fireOnError.call(_, data, form, settings);
            }
          }
        });
      }
      else {
        if (submit === false) {
          _.removeClass(_.settings.submitClass);
          return false;
        }

        // Remove submitting class from form
        _.removeClass(_.settings.submitClass);
        // Fire custom user function, if exists
        if ($.isFunction(_.settings.fireOnError)) {
          _.settings.fireOnError.call(_, data, form, settings);
        }
      }
      if (_.aErroredFields.length) {
        _.aErroredFields[0].focus();
      }
    }
    // End Form Submission
  });


  // ----------------------------------------------------------------------------
  //  Functions
  // ----------------------------------------------------------------------------

  //  Worker Functions
  // ------------------------------------------------------------------
  _.stringExists = function(lookingFor, insideOf) {
    if (insideOf.indexOf(lookingFor) !== -1) {
      return true;
    }
    else {
      return false;
    }
  };

  _.validateEmail = function(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  _.validatePhone = function(phone) {
    var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return re.test(phone);
  };

  _.validateInteger = function(integer) {
    if ($.isNumeric(integer) || _.stringExists(',', integer)) {
      return true;
    }
    else {
      return false;
    }
  };

  _.validateReCaptcha = function() {
    var v = grecaptcha.getResponse();
    if (v.length != 0) {
      return true;
    }
    else {
      return false;
    }
  };

  _.validateFile = function($input) {
    var valid = true;
    var input = $input[0];
    // check for accepted file extensions
    if ($input.attr('accept')) {
      // create array of accepted file extensions
      var acceptedTypes = $input.attr('accept').split(',');
      // loop through array and trim white space
      $.each(acceptedTypes, function(iExtension, sExtension) {
        acceptedTypes[iExtension] = sExtension.trim();
      });
      // loop through files and make sure that they have a valid extension
      $.each(input.files, function(iFile, aFile) {
        var extension = aFile.name.substr((aFile.name.lastIndexOf('.')));
        if ($.inArray(extension, acceptedTypes) === -1) {
          valid = false;
        }
      });
    }
    return valid;
  };


  //  Event Functions
  // ------------------------------------------------------------------
  _.validateOnChange = function() {
    $('input, textarea, password').on('input', function() {
      _.validateFields();
    });

    $('select, input[type="checkbox"], input[type="radio"]').on('change', function() {
      _.validateFields();
    });
  };
};
